// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let AutocompleteV5 = require("../../../autocomplete/AutocompleteV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let SelectInputTextSize = require("../../../common/Form/SelectInputTextSize.bs.js");

function toString(v) {
  if (v === "ACRE") {
    return "acres";
  } else {
    return "sqft";
  }
}

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return toString(x.value);
}

function make(value) {
  return {
    value: value,
    label: toString(value)
  };
}

let LotSizeUnitOption = {
  toString: toString,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  make: make
};

let options = [
  "SQ_FT",
  "ACRE"
].map(make);

function LotSizeUnitSelect(props) {
  let __embedded = props.embedded;
  let status = props.status;
  let onChange = props.onChange;
  let value = props.value;
  let embedded = __embedded !== undefined ? __embedded : false;
  let className = embedded ? "w-[92px] shrink-0 text-base" : SelectInputTextSize.className;
  let classNames = embedded ? ({
      control: param => "!rounded-l-none !border-l-0 !bg-zinc-100 !min-h-9",
      dropdownIndicator: param => "!pl-1.5 !pr-1.5",
      valueContainer: param => "!pl-3 !pr-0",
      indicatorSeparator: param => "!block !self-stretch !w-px !bg-zinc-300 !my-1"
    }) : undefined;
  let selectStatus = embedded || status === undefined ? "Neutral" : (
      status === "ok" ? "Success" : "Failure"
    );
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
      getOptionLabel: getOptionLabel,
      getOptionValue: getOptionValue,
      isSearchable: false,
      onBlur: props.onBlur,
      onChange: v => {
        if (v !== undefined) {
          return onChange(v.value);
        }
      },
      onFocus: props.onFocus,
      options: options,
      value: {
        value: value,
        label: toString(value)
      },
      status: selectStatus,
      classNames: classNames
    }),
    className: className
  });
}

let make$1 = LotSizeUnitSelect;

exports.LotSizeUnitOption = LotSizeUnitOption;
exports.options = options;
exports.make = make$1;
/* options Not a pure module */
